module.exports = __webpack_public_path__ + "static/pinkcardifancy2-75975dbb086cb3b51f3518b1a9d503d7.jpeg";